<template>
  <div class="blockchain">
    <Header />
    <div class="content">
      <Blockchain />
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/common/Footer.vue'
import Header from '../components/common/Header.vue'
import Blockchain from '../components/blockchain/Blockchain.vue'
import { setMode } from "../utils";
export default {
  components: { Header, Blockchain, Footer },
  created() {
    this.$store.commit('setDark', false);
    setMode(false);
  },
}
</script>
<style lang="scss" scoped>
.blockchain {
  .content {
    max-width: 12rem;
    padding-top: 80px;
  }
}
</style>
